import { render, staticRenderFns } from "./NewQuotationAgro.vue?vue&type=template&id=44479975&scoped=true"
import script from "./NewQuotationAgro.vue?vue&type=script&lang=js"
export * from "./NewQuotationAgro.vue?vue&type=script&lang=js"
import style0 from "./NewQuotationAgro.vue?vue&type=style&index=0&id=44479975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44479975",
  null
  
)

export default component.exports